/**
 * @generated SignedSource<<8bf494d7b7f5b306429178020cb53afa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useLatestUserInfo_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"usePersistedWalletAddress_viewer">;
  readonly " $fragmentType": "useLatestUserInfo_viewer";
};
export type useLatestUserInfo_viewer$key = {
  readonly " $data"?: useLatestUserInfo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useLatestUserInfo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useLatestUserInfo_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "fetchUser",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "userId",
          "value": ""
        }
      ],
      "kind": "FragmentSpread",
      "name": "usePersistedWalletAddress_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8eae3a800857f101f27a563113771b58";

export default node;
